import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        height: "100%",
    },
    buttonsContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
    },
    redirectButton: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        padding: "16px",
        cursor: "pointer",
    },
    redirectButtonContainer: {
        display: "flex",
        flexDirection: "column",
        padding: "16px",
        width: "100%",
    },
    redirectButtonTitle: {
        fontSize: "16px",
        fontWeight: 500,
        color: "#353535",
    },
    redirectButtonDescription: {
        fontSize: "14px",
        fontWeight: 400,
        color: "#6C6C6C",
    }
}));